// extracted by mini-css-extract-plugin
export default {"chosenCategoryGrid":"ChosenCategoryGrid_chosenCategoryGrid__NVJKd","ViewedSectionSecondary__3videos":"ChosenCategoryGrid_ViewedSectionSecondary__3videos__7sRBr"};